/**
 * @param rates
 * @param price
 * @param regionCurrency
 * @return {*}
 */
const convertPrice = (rates, price, regionCurrency) => (rates[regionCurrency] ? price * rates[regionCurrency] : price);

export default convertPrice;
